import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import {
  ContinuableListing,
  HttpParamsBuilder,
  IDataSource,
  RestClientContinuable,
  TokenChunkRequest,
} from '@elderbyte/ngx-starter'
import { environment } from '../environments/environment'
import { NewPackage, Package } from './domain/packages/package'
import { Observable } from 'rxjs'
import { WorkBatchPackagesDataSourceBuilder } from './domain/packages/work-batch/WorkBatchPackagesDataSourceBuilder'

@Injectable({
  providedIn: 'root',
})
export class WorkBatchPackagesService extends RestClientContinuable<Package, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)
    super(environment.apiPath + '/packages', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public buildDataSource(): IDataSource<Package> {
    return new WorkBatchPackagesDataSourceBuilder(this).buildDataSource()
  }

  /***************************************************************************
   *                                                                         *
   * /api/packages/work-batch/{workBatchId}                                  *
   *                                                                         *
   **************************************************************************/

  /**
   * Returns a workBatch's packages. The ressource does not take filters.
   */
  public fetchWorkBatchPackages(
    workBatchId: string,
    continuable?: TokenChunkRequest
  ): Observable<ContinuableListing<Package>> {
    const params = new HttpParamsBuilder().appendContinuationRequest(continuable).build()
    return this.http.get<ContinuableListing<Package>>(
      `${this.restEndpoint}/work-batch/${workBatchId}`,
      {
        params,
      }
    )
  }

  public createBatchPkg(newPkg: NewPackage): Observable<Package> {
    return this.http.put<Package>(`${this.restEndpoint}/work-batch/${newPkg.workBatchId}`, newPkg)
  }

  deleteWorkBatchPackages(workBatchId: string, pkgs: Package[]): any {
    const pkgIds = pkgs.map((pkg) => pkg.id)
    const paramsBuilder = new HttpParamsBuilder()
    pkgIds.forEach((pkgId) => paramsBuilder.append('packageIds', pkgId))
    const params = paramsBuilder.build()
    return this.http.delete(`${this.restEndpoint}/work-batch/${workBatchId}`, { params })
  }
}
